import React from 'react';
import styled from 'styled-components';
import {Box} from '@material-ui/core';
import SGBody from 'components/Typography/SGBody';
import {Link} from 'react-router-dom';
import RedirectSwitchParams from './interfaces/RedirectSwitchParams';
import SiteType from 'hooks/useSiteInfo/interfaces/SiteType';

const StyledLink = styled(Link)`
  color: inherit;
  font: inherit;

  &:hover {
    color: ${props => props.theme.activeStateBlue};
  }
`;

const StyledBox = styled(Box)`
  margin-top: 1rem;
`;

interface SwitchConnectivityProps {
  switchRedirectInfo: RedirectSwitchParams;
}

export default function SwitchConnectivity({switchRedirectInfo}: SwitchConnectivityProps) {
  const baseLink = `switch?siteId=${switchRedirectInfo.siteId}`;
  const devicesLink =
    switchRedirectInfo.deviceNames?.map(deviceName => `&deviceName=${deviceName}`).join('') || '';
  // Retail stores don't use the switch-selection flow — all of their switches
  // are always scanned as a group. Skip the `deviceName=` params so the switch
  // connectivity page fetches by `siteId` instead of `switchnames`.
  const isRetailSite = switchRedirectInfo.siteType === SiteType.Retail;
  const link = isRetailSite
    ? baseLink
    : switchRedirectInfo.deviceNames
    ? `${baseLink}${devicesLink}`
    : `/site-search/${baseLink}`;

  return (
    <StyledBox>
      <SGBody variant="b2">
        <StyledLink to={link}>Click here</StyledLink> to be redirected to the switch connectivity
        feature.
      </SGBody>
    </StyledBox>
  );
}
